module.exports = __webpack_public_path__ + "static/media/william.d460f454.jpg";